/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CampCategoryPaginateResponse } from '../../models/camp-category-paginate-response';

export interface GetCampCategoryIndex$Params {

/**
 * Pagination offset
 */
  page?: number;

/**
 * Pagination limit
 */
  limit?: number;

/**
 * Pagination order field ascending
 */
  orderAsc?: 'id' | 'name' | 'label' | 'description' | 'descriptionMeta' | 'descriptionLink' | 'priority';

/**
 * Pagination order field descending
 */
  orderDesc?: 'id' | 'name' | 'label' | 'description' | 'descriptionMeta' | 'descriptionLink' | 'priority';

/**
 * Filter category id
 */
  id?: number;

/**
 * Filter by visible label
 */
  label?: string;

/**
 * Filter by visible name
 */
  name?: string;
}

export function getCampCategoryIndex(http: HttpClient, rootUrl: string, params?: GetCampCategoryIndex$Params, context?: HttpContext): Observable<StrictHttpResponse<CampCategoryPaginateResponse>> {
  const rb = new RequestBuilder(rootUrl, getCampCategoryIndex.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('orderAsc', params.orderAsc, {});
    rb.query('orderDesc', params.orderDesc, {});
    rb.query('id', params.id, {});
    rb.query('label', params.label, {});
    rb.query('name', params.name, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CampCategoryPaginateResponse>;
    })
  );
}

getCampCategoryIndex.PATH = '/v1/camp-category';
